export const KN_API_BASE_URL: string = import.meta.env.VITE_API_URL ?? ''

export const GOOGLE_CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''

export const MICROSOFT_CLIENT_ID: string =
  import.meta.env.VITE_MICROSOFT_CLIENT_ID ?? ''

export const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth'
export const MICROSOFT_AUTH_URL =
  'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'

export const GOOGLE_SCOPES = 'openid profile email'
export const MICROSOFT_SCOPES =
  'openid profile email offline_access https://graph.microsoft.com/User.Read'

export interface IOAuthEnvValidation {
  missing: string[]
}

export const validateOAuthEnv = (): IOAuthEnvValidation => {
  const missing: string[] = []
  if (!KN_API_BASE_URL) missing.push('VITE_API_URL')
  if (!GOOGLE_CLIENT_ID) missing.push('VITE_GOOGLE_CLIENT_ID')
  if (!MICROSOFT_CLIENT_ID) missing.push('VITE_MICROSOFT_CLIENT_ID')
  return { missing }
}
